module.exports = __webpack_public_path__ + "static/media/ad3.65c2cad4.png";